export const operationTypes = [
  'NO APLICA',
  'DEPÓSITO EN EFECTIVO EN CUENTA DE AHORRO',
  'DEPÓSITO EN EFECTIVO EN CUENTA CORRIENTE',
  'RETIRO DE EFECTIVO EN CUENTA CORRIENTE',
  'RETIRO DE EFECTIVO EN CUENTA CORRIENTE',
  'APERTURA CERTIFICADOS DE AHORRO',
  'APERTURA PLAZO FIJO',
  'APERTURA PARTICIPACIÓN',
  'APERTURA DE OBLIGACIONES',
  'CIERRE DE PLAZO FIJO',
  'CIERRE DE PARTICIPACIÓN',
  'CIERRE DE CERTIFICADOS DE AHORROS',
  'CIERRE DE OBLIGACIONES',
  'DEPÓSITO EN CHEQUE EN CUENTA DE AHORRO',
  'DEPÓSITO EN CHEQUE EN CUENTA CORRIENTE',
  'RETIRO DE CHEQUE EN CUENTA CORRIENTE',
  'RETIRO DE CHEQUE EN CUENTA DE AHORRO',
  'OPERACIONES CON CARTE DE CRÉDITO',
  'CONSUMO CON TARJETA DE CRÉDITO',
  'AVANCE DE EFECTIVO CON TARJETA DE CRÉDITO',
  'PAGO A TARJETA DE CRÉDITO',
  'LINEA DE CRÉDITO',
  'CONSUMO CON TARJETA PREPAGADA',
  'ABONO DE TARJETA PREPAGADA',
  'COMPRA DE TITULO VALOR',
  'VENTA DE TITULO VALOR',
  'APERTURA DE FIDEICOMISO',
  'CIERRE DE FIDEICOMISO',
  'OTORGAMIENTO DE FIANZAS',
  'OTORGAMIENTO DE REAFIANZAMIENTO',
  'CONSUMO CON TARJETA DE DEBITO',
  'RETIRO DE EFECTIVO CON TARJETA DE DEBITO',
  'COMPRA DE DIVISA EFECTIVO',
  'COMPRA DE DIVISA CHEQUE',
  "COMPRA DE DIVISA TRAVELLER'S CHECK",
  'VENTA DE DIVISA EFECTIVO',
  'VENTA DE DIVISA CHEQUE',
  "VENTA DE DIVISA TRAVELLER'S CHECK",
  'ENCOMIENDA ELECTRÓNICA RECIBIDA',
  "ENCOMIENDA ELECTRÓNICA ENVIADA",
  "TRANSFERENCIA DE DIVISAS EN EFECTIVO ENVIADA AL EXTERIOR",
  "TRANSFERENCIA DE DIVISAS EN EFECTIVO RECIBIDA DESDE EL EXTERIOR",
  "TRANSFERENCIA NACIONAL DE DIVISAS EN EFECTIVO ENVIADA",
  "TRANSFERENCIA NACIONAL DE DIVISAS EN EFECTIVO RECIBIDA",
  "TRANSFERENCIA DE DIVISAS EN CHEQUE DE GERENCIA ENVIADA AL EXTERIOR",
  "TRANSFERENCIA DE DIVISAS EN CHEQUE DE GERENCIA RECIBIDA DESDE EL EXTERIOR",
  "TRANSFERENCIA NACIONAL DE DIVISAS EN CHEQUE DE GERENCIA ENVIADA",
  "TRANSFERENCIA NACIONAL DE DIVISAS EN CHEQUE DE GERENCIA RECIBIDA",
  "TRANSFERENCIA DE DIVISAS EN TRAVELLER'S CHECK ENVIADA AL EXTERIOR",
  "TRANSFERENCIA DE DIVISAS EN TRAVELLER'S CHECK RECIBIDA DESDE EL EXTERIOR",
  "TRANSFERENCIA NACIONAL DE DIVISAS EN TRAVELLER'S CHECK ENVIADA",
  "TRANSFERENCIA NACIONAL DE DIVISAS EN TRAVELLER'S CHECK RECIBIDA",
  "TRANSFERENCIA NACIONAL EN BOLIVARES ENVIADA",
  "TRANSFERENCIA NACIONAL EN BOLIVARES RECIBIDA",
];
